/* tslint:disable */
/* eslint-disable */
/**
 * Public Track API
 * Public Track APIs provide customers access to their SPiDRs, Security Focuses and SPiDR Blueprints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TechnicalDomain = {
    Perimeter: 'Perimeter',
    AuthenticationAndAccessControl: 'Authentication and Access Control',
    CloudIaaSPaaS: 'Cloud (IaaS/PaaS)',
    PkiAndKeyManagement: 'PKI and Key management',
    ContainerizationAndOrchestration: 'Containerization and Orchestration',
    SoftwareAsAService: 'Software as a Service',
    RiskAndCompliance: 'Risk and Compliance',
    Endpoint: 'Endpoint',
    Network: 'Network',
    ArcticWolf: 'Arctic Wolf',
    AssetManagement: 'Asset Management'
} as const;
export type TechnicalDomain = typeof TechnicalDomain[keyof typeof TechnicalDomain];


export function TechnicalDomainFromJSON(json: any): TechnicalDomain {
    return TechnicalDomainFromJSONTyped(json, false);
}

export function TechnicalDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): TechnicalDomain {
    return json as TechnicalDomain;
}

export function TechnicalDomainToJSON(value?: TechnicalDomain | null): any {
    return value as any;
}

